/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

// IMPORTANT: exports added here are public
export { JsonTraceSerializer } from './trace';
